const actionTransformToSchema = [
  {
    type: 'number',
    name: 'duration',
    label: 'Duration (seconds):',
    min: '0',
    step: 0.25,
    vfeNumber: true,
    events: ['input'],
  },
  {
    type: 'select',
    label: 'Easing:',
    name: 'easing',
    options: {
      linear: 'Linear',
      sinein: 'Smooth Start',
      sineout: 'Smooth End',
      sineinout: 'Smooth Start & End',
      elasticin: 'Elastic Start',
      elasticout: 'Elastic End',
      elasticinout: 'Elastic Start & End',
      backin: 'Overshoot on Start',
      backout: 'Overshoot on End',
      backinout: 'Overshoot on Start & End',
      // linear: 'Linear',
      // sinein: 'SineIn',
      // sineout: 'SineOut',
      // sineinout: 'SineInOut',
      // quadin: 'QuadIn',
      // quadout: 'QuadOut',
      // quadinout: 'QuadInOut',
      // cubicin: 'CubicIn',
      // cubicout: 'CubicOut',
      // cubicinout: 'CubicInOut',
      // quartin: 'QuartIn',
      // quartout: 'QuartOut',
      // quartinout: 'QuartInOut',
      // quintin: 'QuintIn',
      // quintout: 'QuintOut',
      // quintinout: 'QuintInOut',
      // expoin: 'ExpoIn',
      // expoout: 'ExpoOut',
      // expoinout: 'ExpoInOut',
      // circin: 'CircIn',
      // circout: 'CircOut',
      // circinout: 'CircInOut',
      // backin: 'BackIn',
      // backout: 'BackOut',
      // backinout: 'BackInOut',
      // elasticin: 'ElasticIn',
      // elasticout: 'ElasticOut',
      // elasticinout: 'ElasticInOut',
      // bouncein: 'BounceIn',
      // bounceout: 'BounceOut',
      // bounceinout: 'BounceInOut',
    },
    events: ['input'],
  },
  // position
  {
    type: 'number',
    name: 'to_position_x',
    label: 'Position X',
    placeholder: "leave empty for no change in the X direction",
    events: ['input'],
    step: 0.01,
  },
  {
    type: 'number',
    name: 'to_position_y',
    label: 'Position Y',
    placeholder: "leave empty for no change in the Y direction",
    events: ['input'],
    step: 0.01,
  },
  {
    type: 'number',
    name: 'to_position_z',
    label: 'Position Z',
    placeholder: "leave empty for no change in the Z direction",
    events: ['input'],
    step: 0.01,
  },
  // rotation
  {
    type: 'number',
    name: 'to_euler_rotation_x',
    label: 'Rotation X',
    placeholder: "leave empty for no rotation on X axis",
    validation: "number|between:-360,360",
    events: ['input'],
    step: 0.01,
  },
  {
    type: 'number',
    name: 'to_euler_rotation_y',
    label: 'Rotation Y',
    placeholder: "leave empty for no rotation on Y axis",
    validation: "number|between:-360,360",
    events: ['input'],
    step: 0.01,
  },
  {
    type: 'number',
    name: 'to_euler_rotation_z',
    label: 'Rotation Z',
    placeholder: "leave empty for no rotation on Z axis",
    validation: "number|between:-360,360",
    events: ['input'],
    step: 0.01,
  },
  // scale
  {
    type: 'number',
    name: 'to_local_scale',
    label: 'Scale',
    placeholder: "leave empty for no scale change",
    events: ['input'],
    step: 0.01,
  },
]

const actionTransformToValue = {
  type: 'action_transform_to',
  duration: 0,
  easing: 'sineinout',
  // to_position_x: null,
  // to_position_y: null,
  // to_position_z: null,
  // to_euler_rotation_x: 0,
  // to_euler_rotation_y: 0,
  // to_euler_rotation_z: 0,
  // to_local_scale: 1,
}

export { actionTransformToSchema, actionTransformToValue }
